import axios from "axios";
// import store from "@/store";
import router from "@/router";
import { Message } from "element-ui";
import qs from "qs";

/**
 * ajax 封装
 *
 */
class Ajax {
  /**
   *
   */
  constructor() {
    this.axios = axios.create({
      timeout: 30000,
    });

    // 请求拦截器
    this.axios.interceptors.request.use(
      (config) => {
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // 响应拦截器
    this.axios.interceptors.response.use(
      (response) => {
        if (response.data.code == -2) {

          let endTimer = setTimeout(() => {}, 100000);
          for (let i = 0; i <= endTimer; i++) {
            clearInterval(i);
            clearTimeout(i);
          }

          localStorage.removeItem("userInfo");
          router.push("/login");
        }

        if (response.data.code == -3) {
          return Promise.reject(response.data);
        }

        if (response.data.code == -1 || response.data.code == -2) {
          Message.error({
            customClass: "errMsg",
            message: response.data.msg || response.data.data.errmsg,
          });
          return Promise.reject(response.data);
        }

        return response.data;
      },
      (error) => {
        console.log(error.response);
        Message.error({
          customClass: "errMsg",
          message: error.response.data.msg,
        });
        return Promise.reject(error);
      }
    );
  }

  /**
   *
   * @param {*} url
   * @param {*} config
   */
  get(url, config) {
    return this.axios.get(url, config);
  }

  /**
   *
   * @param {*} url
   * @param {*} data
   * @param {*} config
   */
  post(url, data, config) {
    return this.axios.post(url, data, config).then((res) => {
      return res;
    });
  }

  /**
   *
   * @param {*} url
   * @param {*} data
   * @param {*} config
   */
  upload(url, data, config) {
    let sheet = new FormData();
    for (let key in data) {
      sheet.append(key, data[key]);
    }
    return this.axios.post(url, sheet, config);
  }

  /**
   *
   * @param {} config
   */
  request(config) {
    return this.request(config);
  }

  /**
   *
   * @param {*} url
   * @param {*} param
   */
  jsonp(url, param) {
    return new Promise((resolve, reject) => {
      let element = document.createElement("script");
      element.src = url + "?" + qs.stringify(param);
      element.charset = "utf-8";
      element.onload = () => {
        resolve();
        element.remove();
      };
      element.onerror = (e) => {
        reject(e);
      };
      document.body.appendChild(element);
    });
  }

  /**
   * 转到打印。
   * @param {*} location
   * @param {*} param
   */
  print(location, param) {
    let host = window.location.origin;
    let query = qs.stringify({
      ...param,
      is_print: true,
    });
    let url = `${host}${location}?${query}`;
    let path = encodeURIComponent(window.btoa(url));
    location.href = `htreport://${path}`;
  }
}

export const ajax = new Ajax();

export default {
  install(Vue) {
    Vue.prototype.$ajax = ajax;
  },
};
